import { useEffect, useState } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    ReferenceLine,
    ComposedChart,
    Line
} from "recharts";

export default function StackedBarChartProReverseGroupQty({ chartData, percentArray }) {

    const [stackedData, setStackedData] = useState([]);


    useEffect(() => {

        let tempChartData = chartData;

        let percentAge = percentArray;

        let index = 0;
        let collectArr = [];
        for (var key in tempChartData) {
            if (tempChartData.hasOwnProperty(key)) {
                // console.log(key + " -> " + tempChartData[key]);
                // console.log(tempChartData[key])
                // let tempObj = {
                //     name: key,
                //     // ['reason'+index]: index
                // }
                // console.log(tempObj)
    
                let tempData = {};
                for (let i = 0; i < tempChartData[key].length; i++) {
                    // console.log(tempChartData[key][i]);
                    // tempData[i]['reason'] = tempChartData[key][i];
                    tempData['reason_' + (i + 1)] = tempChartData[key][i];
                }
                let finalObj = { name: key, percentage: percentAge[index], ...tempData }
                // console.log({name: key, ...tempData})
                // console.log(finalObj);
                collectArr.push(finalObj);
                // console.log('----------------------------------------')
    
            }
            index++
        };
    
        console.log(collectArr);

        setStackedData(collectArr)

    }, [chartData])


    const CustomTooltip = ({ active, payload, label }) => {

        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <span style={{ display: 'block' }}>{`${payload[0]?.payload?.reason_1?.reason}: ${payload[0]?.payload?.reason_1?.qty?.toLocaleString('en-IN')} `}</span>
                    <span style={{ display: 'block' }}>{`${payload[0]?.payload?.reason_2?.reason}: ${payload[0]?.payload?.reason_2?.qty?.toLocaleString('en-IN')} `}</span>
                    <span style={{ display: 'block' }}>{`${payload[0]?.payload?.reason_3?.reason}: ${payload[0]?.payload?.reason_3?.qty?.toLocaleString('en-IN')} `}</span>
                    
                    {/* <span style={{ display: 'block' }}>{`Return %: ${payload[0]?.payload?.percentage?.return_percent}%`}</span> */}

                    {/* <span style={{ display: 'block' }}>Total: {`
                    ${payload[0]?.payload?.reason_1?.rev + payload[0]?.payload?.reason_2?.rev + payload[0]?.payload?.reason_3?.rev}
                    
                    
                    `}</span> */}

                </div>
            );
        }

        return null;
    };

    const CustomLegend = (props) => {
        const {payload} = props;
        return <div className="bar-legend">Months</div>
      }
  
    return (
        <ResponsiveContainer width="100%" height={400}>
            <ComposedChart
                data={stackedData}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                {/* <Legend content={<CustomLegend />} /> */}
                <Legend
                    payload={[
                    { value: "Product Quality did not meet expectation", id: "reason_1", color: '#0088FE' },
                    { value: "Sizing Issues", id: "reason_2", color: '#00C49F' },
                    { value: "Other Return Reasons", id: "reason_3", color: '#FF8042' },                    
                    ]}
                />
                {/* <Tooltip  /> */}
                {/* <Legend /> */}
                <ReferenceLine y={0} stroke="#000" />
          

                <Bar dataKey="reason_1.qty" stackId="a" fill="#0088FE" />
                <Bar dataKey="reason_2.qty" stackId="a" fill="#00C49F" />
                <Bar dataKey="reason_3.qty" stackId="a" fill="#FF8042" />

                {/* <Line type="monotone" dataKey="percentage.return" stroke="#ff7300" /> */}

            </ComposedChart>
        </ResponsiveContainer>
    );
}